module.exports = __webpack_public_path__ + "static/media/person.63124388.svg";